import axios from "axios";

// In deployments, the hostname can change (custom domains, Emergent deploys).
// Use same-origin API calls on any non-localhost domain to avoid CORS/network errors.
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
let BACKEND_URL = ENV_BACKEND_URL;

if (typeof window !== "undefined") {
  const origin = window.location.origin;
  const isLocalhost = origin.includes("localhost") || origin.includes("127.0.0.1");
  if (!isLocalhost) BACKEND_URL = origin;
}

const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function apiErrorMessage(err) {
  const msg =
    err?.response?.data?.detail ||
    err?.response?.data?.message ||
    err?.message ||
    "Something went wrong";
  return typeof msg === "string" ? msg : "Something went wrong";
}

export async function uploadFile(file, purpose = "general") {
  const form = new FormData();
  form.append("file", file);
  form.append("purpose", purpose);
  const res = await api.post("/uploads", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
